import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="attandances--rule-alert"
//
// Shown only when the attendance has no usable attendance rule (no effective
// rule and no schedule entry). Pops up an alert telling the user performances
// cannot be created right now. The add/confirm buttons are disabled
// server-side; this controller only surfaces the message once per render.
export default class extends Controller {
  static values = { message: String }

  connect() {
    if (this.messageValue) {
      window.alert(this.messageValue)
    }
  }
}
